import React from "react";
import subscriptionReducer from "../reducers/subscription";
import { subscription, requestState } from "../actions";
import axios from "axios";
const SubscriptionContext = React.createContext();
export const SubscriptionProvider = ({ children }) => {
	const initialState = {
		subscriptions: null,
		loading: false,
		error: null,
		success: null,
		currentSubscription: localStorage.getItem("currentSubscription"),
		isValid: null,
		gateways :null
	};

	const [subscriptionState, dispatch] = React.useReducer(subscriptionReducer, initialState);

	const isLoading = () => {
		dispatch({
			type: requestState.LOADING,
		});
	};

	const clearGateway = () => {
		dispatch({
			type: subscription.CLEAR_GATEWAY,
		});
	};

	const getSubscriptions = async () => {
		try {
			const res = await axios.get("/subscriptions", {
				params: {
					user: localStorage.getItem("_id"),
				},
			});
			dispatch({
				type: subscription.GET_SUBSCRIPTIONS,
				payload: {
					subscriptions: res.data,
					currentSubscription: res.data.length > 0 ? res.data[res.data.length - 1] : null,
				},
			});
		} catch (error) {
			dispatch({
				type: requestState.ERROR,
				payload: error.response ? error.response.data.message : error.message,
			});
		}
	};

	const getReferreds = async () => {
		try {
			const res = await axios.get("/referreds", {
				params: {
					user: localStorage.getItem("_id"),
				},
			});
			dispatch({
				type: subscription.GET_REFERREDS,
				payload: res.data,
			});
		} catch (error) {
			dispatch({
				type: requestState.ERROR,
				payload: error.response ? error.response.data.message : error.message,
			});
		}
	};

	const checkSubscription = async () => {
		try {
			const res = await axios.post("/subscriptions/checkSubscription", {
				subscription: localStorage.getItem("subscription"),
			});
			console.log(res.data)
			dispatch({
				type: subscription.CHECK_SUBSCRIPTION,
				payload: res.data?.isValid,
			});
		} catch (error) {
			return dispatch({
				type: requestState.ERROR,
				payload: error.response ? error.response.data.message : error.message,
			});
		}
	};

	const cancelSubscription = async (id) => {
		isLoading();
		try {
			const res = await axios.get("/subscription/cancel/" + id);
			getSubscriptions();
			dispatch({
				type: subscription.CANCEL_SUBSCRIPTION,
				payload: res.data,
			});
		} catch (error) {
			dispatch({
				type: requestState.ERROR,
				payload: error.response ? error.response.data.message : error.message,
			});
		}
	};

	const createSubscription = async (card) => {
		try {
			/**Create card */
			isLoading();
			const res = await axios.post("/subscriptions", card);
			getSubscriptions();
			dispatch({
				type: subscription.CREATE_SUBSCRIPTION,
				payload: res.data.user,
			});
		} catch (error) {
			dispatch({
				type: requestState.ERROR,
				payload: error.response ? error.response.data.message : error.message,
			});
		}
	};

	const updateCard = async (id, card) => {
		try {
			/**Create card */
			isLoading();
			const res = await axios.put("/subscription/" + id, card);
			dispatch({
				type: subscription.UPDATE_SUBSCRIPTION,
				payload: res.data,
			});
		} catch (error) {
			dispatch({
				type: requestState.ERROR,
				payload: error.response ? error.response.data.message : error.message,
			});
		}
	};

	const createSubscriptionWithoutCard = async (user) => {
		isLoading();
		try {
			const subscription = {
				user: user._id,
				customer: user.customer,
			};
			await axios.post("/users/customer/subscriptions", subscription);
			getSubscriptions();
			dispatch({
				type: subscription.CREATE_SUBSCRIPTION,
			});
		} catch (error) {
			dispatch({
				type: requestState.ERROR,
				payload: error.response ? error.response.data.message : error.message,
			});
		}
	};

	const getGateway = async (data) => {
		try {
			const res = await axios.post("/getGateway", {
				phone: data,
			});
			console.log(res.data);
			dispatch({
				type: subscription.GET_GATEWAY,
				payload:res.data
			});
		} catch (e) {
			dispatch({
				type: requestState.ERROR,
				payload: e.response ? e.response.data.message : e.message,
			});
		}
	};


	const finalizeTransaction = async (data) => {
		try {
			const res = await axios.get("/transaction/"+data);
			console.log(res.data);
			getSubscriptions();
			dispatch({
				type: subscription.FINALIZE_TRANSACTION,
				payload: res.data,
			});
		} catch (e) {
			dispatch({
				type: requestState.ERROR,
				payload: e.response ? e.response.data.message : e.message,
			});
		}
	};

	// Clear Errors
	const clearNotification = () =>
		dispatch({
			type: requestState.CLEAR_NOTIFICATION,
		});
	return (
		<SubscriptionContext.Provider
			value={{
				loading: subscriptionState.loading,
				error: subscriptionState.error,
				clearNotification: clearNotification,
				isLoading: isLoading,
				success: subscriptionState.success,
				subscriptions: subscriptionState.subscriptions,
				getSubscriptions: getSubscriptions,
				getReferreds: getReferreds,
				cancelSubscription: cancelSubscription,
				createSubscription: createSubscription,
				currentSubscription: subscriptionState.currentSubscription,
				checkSubscription: checkSubscription,
				createSubscriptionWithoutCard: createSubscriptionWithoutCard,
				isValid: subscriptionState.isValid,
				updateCard: updateCard,
				getGateway: getGateway,
				gateways: subscriptionState.gateways,
				finalizeTransaction: finalizeTransaction,
				clearGateway: clearGateway,
			}}
		>
			{children}
		</SubscriptionContext.Provider>
	);
};

export const useSubscriptionContext = () => React.useContext(SubscriptionContext);
